<template>
  <div class="flex flex-col chat-conversation-panel h-full">
    <div
      class="text-lg font-semibold text-white-700 mb-4 flex items-center justify-center relative"
    >
      <span>🗂️ Conversation History</span>
      <el-tooltip content="Collapse" placement="top">
        <i
          class="el-icon-notebook-2 absolute right-0 cursor-pointer el-button--text"
          @click="$emit('collapse')"
        >
        </i>
      </el-tooltip>
    </div>
    <el-button
      type="primary"
      size="small"
      class="mb-2 w-full"
      icon="el-icon-plus"
      @click="handleNewConversation"
    >
      New Conversation
    </el-button>
    <div
      v-loading="loading"
      element-loading-background="rgba(24, 33, 48, 0.8)"
      class="flex-1 relative"
    >
      <div
        v-if="!conversations.length"
        class="no-data flex items-center justify-center h-full"
      >
        No Data
      </div>
      <div v-else class="flex-1">
        <el-scrollbar class="absolute inset-0 scroll-bar">
          <div class="flex flex-col gap-2">
            <div
              v-for="conversation in conversations"
              :key="conversation.id"
              @click="handleClickItem(conversation)"
              class="overflow-hidden cursor-pointer p-2 rounded transition hover:bg-blue-50 hover:text-blue-600"
              :class="[
                selectedId === conversation.conversationId
                  ? 'bg-blue-100 text-blue-700'
                  : '',
              ]"
            >
              <div>
                <div>Conversation ID:</div>
                <div>{{ conversation.conversationId }}</div>
              </div>
              <div>
                <div>Start Time:</div>
                <div>
                  {{ Number(conversation.startTime) | formatTimestamp }}
                </div>
              </div>
              <div>
                <div>Update Time:</div>
                <div>
                  {{ Number(conversation.updateTime) | formatTimestamp }}
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { getAgentConversations } from "@/api";
export default {
  name: "ChatConversationPanel",
  emits: ["select", "create"],
  props: {
    agentId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      conversations: [],
      selectedId: null,
      loading: false,
    };
  },
  mounted() {
    if (!this.agentId) return;
    this.getAgentConversations();
  },
  methods: {
    handleClickItem(conv) {
      console.log("Selected conversation:", conv);
      this.selectedId = conv.conversationId;
      this.$emit("select", conv);
    },
    async getAgentConversations() {
      try {
        this.loading = true;
        const res = await getAgentConversations(this.agentId);
        this.conversations = res;
      } catch (e) {
        console.error("Failed to fetch conversation list", e);
      } finally {
        this.loading = false;
      }
    },
    handleNewConversation() {
      this.selectedId = null;
      this.$emit("create");
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-conversation-panel {
  width: 280px;
  .no-data {
    text-align: center;
    color: #999;
    padding: 32px 0;
  }
}
</style>
